module.exports = __webpack_public_path__ + "static/img/logoIco.d2a4ac28.jpg";